"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputFlexContainer = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@itwin/itwinui-css/css/input-container.css");
/**
 * Utility component for input container with display flex abilities.
 * @private
 */
exports.InputFlexContainer = react_1.default.forwardRef((props, ref) => {
    const { as: Element = 'div', isDisabled, status, children, className, style, ...rest } = props;
    return (react_1.default.createElement(Element, { className: (0, classnames_1.default)('iui-input-flex-container', className), "data-iui-status": status, "data-iui-disabled": isDisabled ? 'true' : undefined, ref: ref, style: style, ...rest }, children));
});
